import { defaultTheme } from 'react-admin'

export const darkTheme = {
   palette: {
      primary: {
         main: '#90caf9',
      },
      secondary: {
         main: '#FBBA72',
      },
      mode: 'dark',
   },
   sidebar: {
      width: 260,
   },
   components: {
      ...defaultTheme.components,
      RaMenuItemLink: {
         styleOverrides: {
            root: {
               borderLeft: '3px solid #000',
               '&.RaMenuItemLink-active': {
                  borderLeft: '3px solid #90caf9',
               },
            },
         },
      },
      MuiAppBar: {
         styleOverrides: {
            colorSecondary: {
               color: '#ffffffb3',
               backgroundColor: '#616161e6',
            },
         },
      },
   },
   typography: {
      fontFamily: ['-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Arial', 'sans-serif'].join(','),
   },
}

export const lightTheme = {
   palette: {
      primary: {
         main: '#4f3cc9',
      },
      secondary: {
         light: '#5f5fc4',
         main: '#283593',
         dark: '#001064',
         contrastText: '#fff',
      },
      background: {
         default: '#fcfcfe',
      },
      mode: 'light',
   },
   shape: {
      borderRadius: 10,
   },
   sidebar: {
      width: 260,
   },
   components: {
      ...defaultTheme.components,
      RaMenuItemLink: {
         styleOverrides: {
            root: {
               borderLeft: '3px solid #fff',
               '&.RaMenuItemLink-active': {
                  borderLeft: '3px solid #4f3cc9',
               },
            },
         },
      },
      MuiPaper: {
         styleOverrides: {
            elevation1: {
               boxShadow: 'none',
            },
            root: {
               border: '1px solid #e0e0e3',
               backgroundClip: 'padding-box',
            },
         },
      },
      MuiAppBar: {
         styleOverrides: {
            colorSecondary: {
               color: '#808080',
               backgroundColor: '#fff',
            },
         },
      },
      MuiLinearProgress: {
         styleOverrides: {
            colorPrimary: {
               backgroundColor: '#f5f5f5',
            },
            barColorPrimary: {
               backgroundColor: '#d7d7d7',
            },
         },
      },
   },
   typography: {
      fontFamily: ['-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Arial', 'sans-serif'].join(','),
   },
}

export const propticaDarkTheme = {
   ...darkTheme,
   palette: {
      ...darkTheme.palette,
      primary: {
         main: '#C92076',
      },
   },
   components: {
      ...darkTheme.components,
      RaMenuItemLink: {
         styleOverrides: {
            root: {
               borderLeft: '3px solid #000',
               '&.RaMenuItemLink-active': {
                  borderLeft: '3px solid #C92076',
               },
            },
         },
      },
      MuiSvgIcon: {
         styleOverrides: {
            root: {
               color: '#C92076',
            },
         },
      },
   },
}

export const propticaLightTheme = {
   ...lightTheme,
   palette: {
      ...lightTheme.palette,
      primary: {
         main: '#E87BA8',
      },
      secondary: {
         light: '#F2A3C3',
         main: '#E87BA8',
         dark: '#C4567E',
         contrastText: '#fff',
      },
   },
   components: {
      ...lightTheme.components,
      RaMenuItemLink: {
         styleOverrides: {
            root: {
               borderLeft: '3px solid #fff',
               '&.RaMenuItemLink-active': {
                  borderLeft: '3px solid #E87BA8',
               },
            },
         },
      },
      MuiSvgIcon: {
         styleOverrides: {
            root: {
               color: '#E87BA8',
            },
         },
      },
   },
}

